import { mapState } from 'vuex';

export default {
  name: 'Footer',
  computed: {
    ...mapState(['config'])
  }
}
